import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidePanelWrapperComponent } from './components/side-panel-wrapper/side-panel-wrapper.component';
import { CheckoutReviewComponent } from '../../../components/checkout-review/checkout-review.component';



@NgModule({
  declarations: [
    SidePanelWrapperComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    SidePanelWrapperComponent
  ],
  entryComponents: [
    CheckoutReviewComponent
  ]
})
export class SidePanelModule { }
